import BaseRepository from "./BaseRepository";
import OrderAPICall from "../service/OrderAPICall";
import ProductRepository from "./ProductRepository";

class OrderRepository extends BaseRepository {

    fetchOrderList = async (keyword, searchType, timeSpan, start, pageSize, sortBy, sortOrder, filterByOption) => {
        return await new OrderAPICall().fetchOrderList({ keyword, searchType, timeSpan, start, pageSize, sortBy, sortOrder, filterByOption });
    };
    fetchHeaderOrderDetail = async (orderNumber) => {
        return await new OrderAPICall().fetchHeaderOrderDetail({ orderNumber });
    };
    sendEmailOrder = async (from, to, cc, subject, emailBody) => {
        return await new OrderAPICall().sendEmailOrder({ from, to, cc, subject, emailBody });
    };
    fetchOrderListByLineItem = async (orderNumber) => {
        return await new OrderAPICall().fetchOrderListByLineItem({ orderNumber });
    };
    fetchOrderListByDelivery = async (orderNumber) => {
        return await new OrderAPICall().fetchOrderListByDelivery({ orderNumber });
    };
    placeYourOrder = async (params) => {
        return await new OrderAPICall().placeYourOrder(params);
    };
    fetchPlaceOrderItems = async (orderId) => {
        let orderDetail = await new OrderAPICall().fetchPlaceOrderItems(orderId);
        // orderDetail.items.map((v) => {//14990 // 15033_main_orig
        //     v.ERPPartNumber = v.partNumber;
        // });
        // // orderDetail.items = await new ProductRepository().attachProductAndInventoryToAnyObjectNew(orderDetail.items, false, false, false);
        // orderDetail.items = await new ProductRepository().attachProductAndInventoryToAnyObjectNew(orderDetail.items, false, true, false);
        return orderDetail;
    };
    orderDownloadSingleInvoice = async (invoiceNumber) => {
        return await new OrderAPICall().orderDownloadSingleInvoice({
            invoiceNumber
        });
    };
    exportOrder = async (params) => {
        return await new OrderAPICall().exportOrder(params);
    };
    fetchOrderExportCount = async () => {
        return await new OrderAPICall().getExportOrderCount();
    };

    fetchManufacturerList = async () => {
       return await new OrderAPICall().fetchManufacturerList();
    };
    sendOrderPOLineItemEmail = async(params) => {
        return await new OrderAPICall().sendOrderPOLineItemEmail(params);
    };
    fetchOrderReturnReasonList = async() => {
        return await new OrderAPICall().fetchOrderReturnReasonsList();
    }
    placeOrderReturnRequest = async(params) => {
        return await new OrderAPICall().placeOrderReturnRequest(params);
    }

    scheduleOrderReport = async (params) => {
        return await new OrderAPICall().scheduleOrderReport(params);
    };

    getOrderReports = async (params) => {
        return await new OrderAPICall().getOrderReports(params);
    };

    deleteOrderReport = async (params) => {
        return await new OrderAPICall().deleteOrderReport(params);
    }
}

export default OrderRepository;